import InviteToWorkspace from './InviteToWorkspace';
export default InviteToWorkspace;
